
export default function MethodSection() {
  const principles = [
    {
      icon: "ri-lightbulb-line",
      title: "Keep It Simple",
      description: "No confusing grammar rules or complicated explanations. We break everything down into easy-to-understand pieces.",
      color: "yellow"
    },
    {
      icon: "ri-target-line",
      title: "Focus on Practical Use",
      description: "Every lesson teaches you something you'll actually use in real conversations, not textbook theory.",
      color: "blue"
    },
    {
      icon: "ri-speed-line",
      title: "Get Results Fast",
      description: "Our method is designed to get you speaking confidently in weeks, not months or years.",
      color: "green"
    },
    {
      icon: "ri-heart-line",
      title: "Make It Enjoyable",
      description: "Learning should be fun! Our engaging approach keeps you motivated and excited to continue.",
      color: "red"
    }
  ];

  const getColorClasses = (color: string) => {
    const colors = {
      yellow: "bg-yellow-100 text-yellow-600",
      blue: "bg-blue-100 text-blue-600",
      green: "bg-green-100 text-green-600",
      red: "bg-red-100 text-red-600"
    };
    return colors[color as keyof typeof colors] || colors.blue;
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our Teaching Philosophy
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            These four principles guide everything we do. They're the reason our students 
            succeed where others have struggled.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {principles.map((principle, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-lg">
              <div className={`w-16 h-16 rounded-full flex items-center justify-center mb-6 ${getColorClasses(principle.color)}`}>
                <i className={`${principle.icon} text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{principle.title}</h3>
              <p className="text-gray-600 leading-relaxed">{principle.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            The Result? Students Who Actually Speak English
          </h3>
          <p className="text-gray-600 mb-6 max-w-3xl mx-auto">
            While other programs leave students knowing grammar rules but unable to have a conversation, 
            our students are confidently speaking English in real-world situations.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="text-3xl font-bold text-blue-600 mb-2">92%</div>
              <div className="text-gray-600">Report improved confidence</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-green-600 mb-2">4.8/5</div>
              <div className="text-gray-600">Average student rating</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-purple-600 mb-2">3 weeks</div>
              <div className="text-gray-600">Average time to see results</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
